var CheckoutDeliveriesJs = (function ($) {
    var selectDefaultMethod = function (defaultDeliveryMethod) {
        if($(".j-delivery-method-radio-buttons input[type='radio']").is(':checked') === false ){
            $(".j-delivery-method-radio-buttons input[type='radio']").filter("[value='"+defaultDeliveryMethod+"']").first().trigger("click");
        }
    };
    function showDeliveryDescriptionIfAvailable(deliveryRadioButtonElement) {
        $(".delivery-method-description").hide();
        var deliveryMethodElement = deliveryRadioButtonElement.closest(".delivery-method");
        if (deliveryMethodElement.length) {
            var deliveryMethodDescriptionElement = deliveryMethodElement.find(".delivery-method-description").first();
            if (deliveryMethodDescriptionElement.length) {
                deliveryMethodDescriptionElement.show();
            }
        }
    }

    function initializeDeliveryDescription() {
        var deliveryMethodRadioButtons = ".j-delivery-method-radio-buttons input[type='radio']";
        var deliveryMethodRadioButtonElements = $(deliveryMethodRadioButtons);
        if (deliveryMethodRadioButtonElements.length && !$(".delivery-details-container").length) {
            var checkedDeliveryMethod = $(deliveryMethodRadioButtons + "[name=deliveryMethod]:checked");
            showDeliveryDescriptionIfAvailable(checkedDeliveryMethod);
            deliveryMethodRadioButtonElements.on('click', function () {
                showDeliveryDescriptionIfAvailable($(this));
            });
        }
    }
    
    return {
        selectDefaultMethod: selectDefaultMethod,
        initializeDeliveryDescription: initializeDeliveryDescription
    }
}) (jQuery);

$(document).ready(function() {
    if ($(".j-delivery-method-radio-buttons").length > 0) {
        const selectedDeliveryMethod = $('#selectedDeliveryMethod').val();
        $('input[name="deliveryMethod"]').each(function () {
            if (selectedDeliveryMethod === $(this).val()) {
                $(`input[name="deliveryMethod"][value="${$(this).val()}"]`).prop('checked', true).trigger('click');
            }
        });
        defaultDeliveryMethod = $("#defaultDeliveryMethod").val();
        CheckoutDeliveriesJs.selectDefaultMethod(defaultDeliveryMethod);
    }
    if (typeof customCountyHandling !== 'undefined' && $.isFunction(customCountyHandling)) {
            customCountyHandling($(".invoice-county-select"), $(".invoice-county-select option"));
        }

    if (typeof customCountyHandling !== 'undefined' && $.isFunction(customCountyHandling)) {
        customCountyHandling($(".delivery-county-select"), $(".delivery-county-select option"));
    }

    $(".invoice-county-select").select2();
    $(".invoice-town-select").select2();
    $(".delivery-county-select").select2();
    $(".delivery-town-select").select2();

     window.THEME.$document.on('countryChangedEvent', function(){
          $(".j-delivery-method-radio-buttons input[type='radio']").filter("[value='different']").first().trigger("click");
     });


    CheckoutDeliveriesJs.initializeDeliveryDescription();
});
